import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

// ✅ Images
import bgImage from "../../images/bg/testimonial-bg.png";
import kotCrown from "../../images/avatar/kot-crown.png";

// What Our Clients Say — realistic client reviews
// (👇 asli client naam/company confirm hone par yahan update karen)
const testimonials = [
  {
    id: 1,
    source: "Commerce X",
    rating: "01",
    content:
      "“We were running our store, warehouse, and accounts on three disconnected systems. Commerce X pulled them into one platform — stock, orders, and reporting finally match. Reconciliation that took our team two days now takes an hour.”",
    name: "Bilal Ahmed",
    designation: "COO, Mehran Retail (Karachi)",
    avatar: kotCrown,
  },
  {
    id: 2,
    source: "Digital Systems",
    rating: "02",
    content:
      "“The ERP rollout was the smoothest enterprise project we've done. Their team understood our manufacturing floor before writing a line of code, and the dashboards our directors use every morning came out of that.”",
    name: "Sana Tariq",
    designation: "Head of IT, Kohinoor Industries",
    avatar: kotCrown,
  },
  {
    id: 3,
    source: "AppForge",
    rating: "03",
    content:
      "“Our mobile app went from concept to 40,000 downloads in the first quarter. Clean design, fast, and it hasn't crashed on us once. Support has been genuinely responsive whenever we needed changes.”",
    name: "Usman Raza",
    designation: "Founder, DaastanGo",
    avatar: kotCrown,
  },
  {
    id: 4,
    source: "Growth IQ",
    rating: "04",
    content:
      "“They didn't just run ads — they rebuilt our positioning first, then the funnel. Cost per lead dropped by nearly half in three months and, more importantly, the leads actually convert now.”",
    name: "Ayesha Khan",
    designation: "Marketing Director, Folio Foods",
    avatar: kotCrown,
  },
  {
    id: 5,
    source: "EpiTech",
    rating: "05",
    content:
      "“We enrolled a batch of fresh graduates and got back deployment-ready engineers. The instructors clearly work in the field — the training was practical, not textbook. Half the cohort was hired within a month.”",
    name: "Dr. Faisal Mahmood",
    designation: "Dean of Computing, Lahore",
    avatar: kotCrown,
  },
  {
    id: 6,
    source: "Venture Xcelerator",
    rating: "06",
    content:
      "“The mentorship and investor introductions were worth more than the funding. As a first-time founder I had access to legal, product, and growth help under one roof — it saved us at least a year of mistakes.”",
    name: "Hamza Sheikh",
    designation: "Co-founder, Qissa Labs",
    avatar: kotCrown,
  },
];

const TestimonialSection: React.FC = () => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".testimonial.bg_img");
    if (bgEl) bgEl.style.backgroundImage = `url(${bgImage})`;
  }, []);

  return (
    <section className="testimonial pb-150 bg_img">
      <div className="container">
        <div className="sec-title sec-title-center tes-sec-title text-center mb-50">
          <span className="sub-title mb-15">What Our Clients Say</span>
          <h2 className="title">
            Trusted by the businesses we help innovate and grow
          </h2>
        </div>
      </div>

      <div className="xb-testimonial-slider">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          speed={400}
          spaceBetween={30}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1700: { slidesPerView: 5 },
            1600: { slidesPerView: 4 },
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            576: { slidesPerView: 1 },
            0: { slidesPerView: 1 },
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="xb-testimonial-item">
                <div className="xb-item--inner xb-border">
                  <ul className="xb-item--rating list-unstyled ul_li">
                    <li>
                      <i className="fa-solid fa-star-sharp"></i>
                    </li>
                    <li>{item.source}</li>
                    <li>{item.rating}</li>
                  </ul>
                  <p className="xb-item--content">{item.content}</p>
                  <div className="xb-item--author ul_li">
                    <div className="xb-item--avatar">
                      <img src={item.avatar} alt={item.name} />
                    </div>
                    <div className="xb-item--holder">
                      <h3 className="xb-item--name">{item.name}</h3>
                      <span className="xb-item--desig">{item.designation}</span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
